import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Modal, Nav, Row, Tab, Button } from "react-bootstrap";
import { toast } from "react-toastify";

import { fetchAttorneylist } from "../../Redux/search/actions";
import api from "../../api/api";
import { createCoCounsel, searchCoCounselFirms, setCoCounselFavorite } from "../../api/coCounsel";
import {
  buildCoCounselCreatePayload,
  getCoCounselError,
} from "../CaseDashboard/CoCounsel/coCounsel.mjs";
import PR from "../../assets/state-svg/puerto-rico";
import GU from "../../assets/state-svg/guam";
import MP from "../../assets/state-svg/marian";
import VI from "../../assets/state-svg/us-virigin-island";
import SelectStateModal from "../TreatmentPage/modals/state-modal/SelectStateModal";
import { addClickRecord, formatPhoneNumber, getCaseId, getClientId } from "../../Utils/helper";

const CounsellingModal = ({
  _setOpen,
  open,
  close,
  refetch,
  clientId = getClientId(),
  caseId = getCaseId(),
}) => {
  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  const [providerType, setProviderType] = useState("favorite-lawfirms");
  const [saving, setSaving] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [, setNotice] = useState("");
  const searchAttorneyData = useSelector((state) => state?.search.searchAttorneyData);
  const dispatch = useDispatch();

  const [searchFirmFavorite, setSearchFirmFavorite] = useState({
    firmName: "",
  });
  const [debouncedSearchTermFavorite, setDebouncedSearchTermFavorite] = useState("");
  const [attorneyDataFavorite, setAttorneyDataFavorite] = useState([]);
  const [favoritesStatus, setFavoritesStatus] = useState("loading");
  const favoriteRequestsInFlight = useRef(new Set());

  useEffect(() => {
    const handler = setTimeout(() => {
      const term = searchFirmFavorite.firmName.trim();
      setDebouncedSearchTermFavorite(term.length >= 3 ? term : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchFirmFavorite.firmName]);

  // Lists every favorite with nothing typed; 3+ characters narrows the list.
  // Refetches when the tab is re-entered so firms starred in the directory show up.
  useEffect(() => {
    if (providerType !== "favorite-lawfirms") return undefined;
    let current = true;
    setFavoritesStatus("loading");
    searchCoCounselFirms({ favorites: true, query: debouncedSearchTermFavorite })
      .then((firms) => {
        if (!current) return;
        setAttorneyDataFavorite(firms || []);
        setFavoritesStatus("ready");
      })
      .catch((error) => {
        if (!current) return;
        console.error(error);
        setAttorneyDataFavorite([]);
        setFavoritesStatus("error");
      });
    return () => {
      current = false;
    };
  }, [providerType, debouncedSearchTermFavorite]);

  // Tab 1

  const [searchFirmByName, setSearchFirmByName] = useState({
    firmName: "",
  });
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [attorneyData, setAttorneyData] = useState([]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchFirmByName.firmName.length >= 3) {
        setDebouncedSearchTerm(searchFirmByName.firmName);
      } else if (searchFirmByName.firmName.length <= 2) {
        setDebouncedSearchTerm("");
        setAttorneyData([]);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [searchFirmByName.firmName]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      dispatch(fetchAttorneylist(debouncedSearchTerm, ""));
    }
  }, [debouncedSearchTerm, dispatch]);

  useEffect(() => {
    setAttorneyData(searchAttorneyData || []);
  }, [searchAttorneyData]);

  // tab 2

  const [attorneyInfo, setAttorneyInfo] = useState({
    firmName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    fax: "",
    email: "",
    website: "",
    teamData: [
      { first_name: "", last_name: "", email: "", phone: "" },
      { first_name: "", last_name: "", email: "", phone: "" },
      { first_name: "", last_name: "", email: "", phone: "" },
      { first_name: "", last_name: "", email: "", phone: "" },
      { first_name: "", last_name: "", email: "", phone: "" },
      { first_name: "", last_name: "", email: "", phone: "" },
    ],
  });
  const [statesAbrs, setStatesAbrs] = useState([]);
  const [stateShow, setStateShow] = React.useState(false);
  const handleStateShow = () => setStateShow(!stateShow);
  const stateMap = {
    PR: PR,
    GU: GU,
    VI: VI,
    MP: MP,
  };
  const specialStates = Object.keys(stateMap);
  const fetchSatesData = async () => {
    try {
      const response = await api.get(`${origin}/api/states/`);
      if (response.status === 200) {
        setStatesAbrs(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSatesData();
  }, []);

  const handlePhoneInput = (event) => {
    setAttorneyInfo((current) => ({
      ...current,
      phone: formatPhoneNumber(event.target.value),
    }));
  };

  const handleFaxInput = (event) => {
    setAttorneyInfo((current) => ({
      ...current,
      fax: formatPhoneNumber(event.target.value),
    }));
  };

  const updateTeamMember = (index, field, value) => {
    setAttorneyInfo((current) => ({
      ...current,
      teamData: current.teamData.map((member, memberIndex) =>
        memberIndex === index ? { ...member, [field]: value } : member
      ),
    }));
  };

  const [selectedAttorney, setSelectedAttorney] = useState(null);

  const handleAttorneySelection = (item) => {
    setSelectedAttorney((current) => (current?.id === item.id ? null : item));
    addClickRecord(999, 1);
  };

  const handleAttorneyKeyDown = (event, item) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleAttorneySelection(item);
    }
  };

  const applyFavorite = (directoryId, favorite) => {
    const update = (rows) =>
      rows.map((row) => (row.id === directoryId ? { ...row, favorite } : row));
    setAttorneyDataFavorite(update);
    setAttorneyData(update);
  };

  // Optimistic: flip the star (and drop unstarred firms from the favorites list) right away,
  // then roll back if the POST fails.
  const toggleFavorite = async (event, item) => {
    event.stopPropagation();
    if (favoriteRequestsInFlight.current.has(item.id)) return;
    favoriteRequestsInFlight.current.add(item.id);
    addClickRecord(999, 1);
    const favorite = !item.favorite;
    const favoritesIndex = attorneyDataFavorite.findIndex((row) => row.id === item.id);
    applyFavorite(item.id, favorite);
    if (!favorite && favoritesIndex !== -1) {
      setAttorneyDataFavorite((rows) => rows.filter((row) => row.id !== item.id));
      if (providerType === "favorite-lawfirms") {
        setSelectedAttorney((current) => (current?.id === item.id ? null : current));
      }
    }
    try {
      const result = await setCoCounselFavorite(item.id, favorite);
      applyFavorite(item.id, result?.favorite ?? favorite);
    } catch (error) {
      applyFavorite(item.id, !favorite);
      if (!favorite && favoritesIndex !== -1) {
        setAttorneyDataFavorite((rows) =>
          rows.some((row) => row.id === item.id)
            ? rows
            : [...rows.slice(0, favoritesIndex), item, ...rows.slice(favoritesIndex)]
        );
      }
      toast.error(
        error.response?.data?.error || "Unable to update the favorite. Please try again."
      );
    } finally {
      favoriteRequestsInFlight.current.delete(item.id);
    }
  };

  const handleFavoriteKeyDown = (event, item) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleFavorite(event, item);
    }
  };

  const renderFavoriteStar = (item, rowNumber) => (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      role="button"
      tabIndex={0}
      aria-label={`Favorite firm ${rowNumber}`}
      aria-pressed={Boolean(item?.favorite)}
      onClick={(event) => toggleFavorite(event, item)}
      onKeyDown={(event) => handleFavoriteKeyDown(event, item)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <path
        d="M12.5 0L16 8.5L25 9L18 15L20 25L12.5 20L5 25L7 15L0 9L9 8.5Z"
        fill={item?.favorite ? "gold" : "var(--primary-30)"}
      />
      <text
        x="12.5"
        y="17"
        textAnchor="middle"
        fontSize={rowNumber > 9 ? "9px" : "11px"}
        fontWeight="600"
        fill="black"
      >
        {rowNumber}
      </text>
    </svg>
  );

  const submitCoCounsel = async () => {
    if (saving) return;
    setSubmitError("");
    setNotice("");
    setSaving(true);
    try {
      const isNewFirm = providerType === "addNewlawFirms";
      if (!isNewFirm && !selectedAttorney) throw new Error("Select a firm from the directory.");
      const payload = buildCoCounselCreatePayload({
        directory: isNewFirm ? null : selectedAttorney,
        firm: attorneyInfo,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });
      addClickRecord(999, 1);
      const result = await createCoCounsel(clientId, caseId, payload);
      await refetch?.();
      if (result.created === false) {
        setNotice(
          "This firm is already on the case. Its existing co-counsel relationship has been refreshed."
        );
      } else {
        close();
      }
    } catch (error) {
      if (error.response?.status === 409 && error.response?.data?.code === "email_exists") {
        toast.error(
          "This email already exists. Please search the directory and select the existing firm."
        );
        return;
      }
      setSubmitError(getCoCounselError(error));
    } finally {
      setSaving(false);
    }
  };

  const handleByDirectory = () => {
    if (saving) return;
    setSubmitError("");
    const isNewFirm = providerType === "addNewlawFirms";
    if (isNewFirm && !attorneyInfo.firmName.trim()) {
      setSubmitError("Enter the firm name.");
      return;
    }
    submitCoCounsel();
  };

  useEffect(() => {
    const AttorneyFixedWidth = () => {
      const attorneyColumns = [...document.querySelectorAll(".fix-width-to-min-content")];

      if (attorneyColumns.length === 0) return;
      if (attorneyData) {
        let providerMaxWidth = 100; // Default width
        attorneyColumns.forEach((col) => {
          const colWidth = col.offsetWidth;
          if (colWidth > providerMaxWidth) {
            providerMaxWidth = colWidth;
          }
        });
        attorneyColumns.forEach((col) => {
          col.style.minWidth = `${providerMaxWidth}px`;
          col.style.width = `${providerMaxWidth}px`;
        });
      }
    };

    // setMaxColumnWidth(calculateMaxWidth());
    AttorneyFixedWidth();
  }, [attorneyData]);

  const showFavoritesEmpty = favoritesStatus !== "loading" && attorneyDataFavorite.length === 0;

  return (
    <>
      <Modal
        show={open}
        onHide={saving ? undefined : close}
        dialogClassName="max-1050 modal-dialog-centered "
        contentClassName="custom-modal-new-provider"
        size="lg"
      >
        <div style={{ minHeight: "490px" }}>
          <Modal.Header className="tfbp-modal-header">
            <Modal.Title
              className="tfbp-modal-title"
              style={{
                textTransform: "uppercase",
              }}
            >
              Add Co-Counselling Firm
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            // ref={modalBodyRef}
            style={{ minHeight: "500px", padding: "0px" }}
          >
            {submitError && (
              <div className="alert alert-danger p-2 m-1" role="alert">
                {submitError}
              </div>
            )}
            <div className="custom-tab">
              <Tab.Container defaultActiveKey={"favorite-lawfirms"}>
                <Nav
                  variant="tabs"
                  className="justify-content-around"
                  style={{ marginTop: "5px", marginBottom: "5px" }}
                >
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-before"
                    eventKey="favorite-lawfirms"
                    onClick={() => {
                      addClickRecord(999, 1);
                      setProviderType("favorite-lawfirms");
                      setSelectedAttorney(null);
                      setSubmitError("");
                      setNotice("");
                    }}
                  >
                    Favorite CoCounseling Firms
                  </Nav.Link>
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                    eventKey="directory-lawfirms"
                    onClick={() => {
                      addClickRecord(999, 1);
                      setProviderType("directory-lawfirms");
                      setSelectedAttorney(null);
                      setSubmitError("");
                      setNotice("");
                      setAttorneyData([]);
                    }}
                  >
                    Directory Law Firms
                  </Nav.Link>
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-after"
                    eventKey="addNewlawFirms"
                    onClick={() => {
                      addClickRecord(999, 1);
                      setProviderType("addNewlawFirms");
                      setSelectedAttorney(null);
                      setSubmitError("");
                      setNotice("");
                    }}
                  >
                    Add New Law Firm
                  </Nav.Link>
                </Nav>
                <div className="">
                  <Tab.Content>
                    <Tab.Pane
                      eventKey="favorite-lawfirms"
                      style={{
                        scrollbarWidth: "none",
                      }}
                    >
                      <Row style={{ paddingLeft: "15px", paddingRight: "15px" }} className="mx-0">
                        <Col md={12} className="p-0">
                          <div className="row mx-0 align-items-center custom-margin-bottom">
                            <div className="col-md-12 ps-0 height-25 pe-0">
                              <input
                                type="text"
                                placeholder="Type 3 Characters to Search for a Firm"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Type 3 Characters to Search for a Firm";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                className="form-control height-25"
                                value={searchFirmFavorite.firmName}
                                onChange={(e) =>
                                  setSearchFirmFavorite({
                                    ...searchFirmFavorite,
                                    firmName: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mx-0">
                        <div
                          style={{
                            height: "424px",
                            overflowY: "auto",
                            width: "100%",
                            scrollbarWidth: "none",
                          }}
                        >
                          <table
                            className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25"
                            id="treatment-summary-table"
                            style={{ width: "100%" }}
                          >
                            <thead
                              style={{
                                position: "sticky",
                                top: "0",
                              }}
                            >
                              <tr id="tb-header">
                                <th
                                  style={{ width: "25px", maxWidth: "25px", minWidth: "25px" }}
                                  className=" td-autosize color-grey-2 p-l-5 text-center"
                                />
                                <th className="text-center td-autosize color-grey-2">Firm Name</th>
                                <th className="color-grey-2 p-l-5 text-center" />
                                <th className="text-center td-autosize color-grey-2">Address</th>
                                <th className="color-grey-2 p-l-5 text-center" />
                                <th
                                  style={{
                                    width: "110px",
                                  }}
                                  className=" text-center td-autosize color-grey-2"
                                >
                                  Phone
                                </th>
                              </tr>
                            </thead>

                            <tbody
                              style={{
                                maxHeight: "399px",
                                overflowY: "auto",
                                width: "100%",
                                scrollbarWidth: "none",
                              }}
                            >
                              {attorneyDataFavorite?.map((item, index) => {
                                const isSelected = selectedAttorney?.id === item.id;
                                return (
                                  <tr
                                    key={item.id}
                                    className={"height-25"}
                                    id=""
                                    data-table_id={36}
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: isSelected ? "var(--primary-50)" : "",
                                    }}
                                    aria-selected={isSelected}
                                    tabIndex={0}
                                    onClick={() => handleAttorneySelection(item)}
                                    onKeyDown={(event) => handleAttorneyKeyDown(event, item)}
                                  >
                                    <td
                                      className=" td-autosize color-black"
                                      style={{ height: "25px" }}
                                    >
                                      <div
                                        className="d-flex align-items-center"
                                        style={{ width: "fit-content" }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center text-center text-white specialty-icon"
                                          style={{
                                            height: "25px",
                                          }}
                                        >
                                          {renderFavoriteStar(item, index + 1)}
                                        </span>
                                      </div>
                                    </td>
                                    <td
                                      id=""
                                      className="text-start td-autosize p-l-5 p-r-5 color-black"
                                      style={{ fontWeight: "600" }}
                                    >
                                      <div
                                        className="d-flex p-r-5 p-l-5 align-items-center justify-content-start "
                                        style={{
                                          height: "25px",

                                          color: "black",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {item?.office_name || ""}
                                      </div>
                                    </td>
                                    <td />

                                    <td
                                      id=""
                                      className="text-start p-l-5 p-r-5 color-black"
                                      style={{ fontWeight: "600" }}
                                    >
                                      <div className="d-flex  height-25 p-r-5 p-l-5 align-items-center justify-content-start ">
                                        {(() => {
                                          const streetAddress = [
                                            item?.main_contact?.[0]?.address1,
                                            item?.main_contact?.[0]?.address2,
                                          ]
                                            .filter(Boolean)
                                            .join(" "); // use space instead of comma

                                          const cityStateZip = [
                                            item?.main_contact?.[0]?.city,
                                            item?.main_contact?.[0]?.state,
                                            item?.main_contact?.[0]?.zip,
                                          ]
                                            .filter(Boolean)
                                            .join(","); // combine with spaces

                                          const fullAddress = [streetAddress, cityStateZip]
                                            .filter(Boolean)
                                            .join(", ");
                                          return fullAddress.length > 90
                                            ? fullAddress.substring(0, 90) + "..."
                                            : fullAddress;
                                        })()}
                                      </div>
                                    </td>
                                    <td />

                                    <td
                                      id="phone-padding-tables-new-provider"
                                      className="text-start p-l-5 p-r-5 color-black"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {formatPhoneNumber(item?.phone)}
                                    </td>
                                  </tr>
                                );
                              })}
                              {showFavoritesEmpty && (
                                <tr className="height-25">
                                  <td colSpan={6} className="text-center color-grey-2">
                                    {favoritesStatus === "error"
                                      ? "Unable to load favorite firms."
                                      : debouncedSearchTermFavorite
                                        ? "No favorite firms match this search."
                                        : "No favorite firms yet. Star a firm in Directory Law Firms to add it here."}
                                  </td>
                                </tr>
                              )}
                              {Array.from({
                                length: Math.max(
                                  0,
                                  16 - attorneyDataFavorite.length - (showFavoritesEmpty ? 1 : 0)
                                ),
                              }).map((_, index) => (
                                <tr key={index} className="fake-rows-new-provider height-25">
                                  <td colSpan={12} />
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane
                      eventKey="directory-lawfirms"
                      style={{
                        scrollbarWidth: "none",
                      }}
                    >
                      <Row style={{ paddingLeft: "15px", paddingRight: "15px" }} className="mx-0">
                        <Col md={12} className="p-0">
                          <div className="row mx-0 align-items-center custom-margin-bottom">
                            <div className="col-md-12 ps-0 height-25 pe-0">
                              <input
                                type="text"
                                placeholder="Type 3 Characters to Search for a Firm"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Type 3 Characters to Search for a Firm";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                className="form-control height-25"
                                value={searchFirmByName.firmName}
                                onChange={(e) =>
                                  setSearchFirmByName({
                                    ...searchFirmByName,
                                    firmName: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mx-0">
                        <div
                          style={{
                            height: "424px",
                            overflowY: "auto",
                            width: "100%",
                            scrollbarWidth: "none",
                          }}
                        >
                          <table
                            className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25"
                            id="treatment-summary-table"
                            style={{ width: "100%" }}
                          >
                            <thead
                              style={{
                                position: "sticky",
                                top: "0",
                              }}
                            >
                              <tr id="tb-header">
                                <th
                                  style={{ width: "25px", maxWidth: "25px", minWidth: "25px" }}
                                  className=" td-autosize color-grey-2 p-l-5 text-center"
                                />
                                <th className="text-center td-autosize color-grey-2">Firm Name</th>
                                <th className="color-grey-2 p-l-5 text-center" />
                                <th className="text-center td-autosize color-grey-2">Address</th>
                                <th className="color-grey-2 p-l-5 text-center" />
                                <th
                                  style={{
                                    width: "110px",
                                  }}
                                  className=" text-center td-autosize color-grey-2"
                                >
                                  Phone
                                </th>
                              </tr>
                            </thead>

                            <tbody
                              style={{
                                maxHeight: "399px",
                                overflowY: "auto",
                                width: "100%",
                                scrollbarWidth: "none",
                              }}
                            >
                              {attorneyData?.map((item, index) => {
                                const isSelected = selectedAttorney?.id === item.id;
                                return (
                                  <tr
                                    key={item.id}
                                    className={"height-25"}
                                    id=""
                                    data-table_id={36}
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: isSelected ? "var(--primary-50)" : "",
                                    }}
                                    aria-selected={isSelected}
                                    tabIndex={0}
                                    onClick={() => handleAttorneySelection(item)}
                                    onKeyDown={(event) => handleAttorneyKeyDown(event, item)}
                                  >
                                    <td
                                      className=" td-autosize color-black"
                                      style={{ height: "25px" }}
                                    >
                                      <div
                                        className="d-flex align-items-center"
                                        style={{ width: "fit-content" }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center text-center text-white specialty-icon"
                                          style={{
                                            height: "25px",
                                          }}
                                        >
                                          {renderFavoriteStar(item, index + 1)}
                                        </span>
                                      </div>
                                    </td>
                                    <td
                                      id=""
                                      className="text-start td-autosize p-l-5 p-r-5 color-black"
                                      style={{ fontWeight: "600" }}
                                    >
                                      <div
                                        className="d-flex p-r-5 p-l-5 align-items-center justify-content-start "
                                        style={{
                                          height: "25px",

                                          color: "black",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {item?.office_name || ""}
                                      </div>
                                    </td>
                                    <td />

                                    <td
                                      id=""
                                      className="text-start p-l-5 p-r-5 color-black"
                                      style={{ fontWeight: "600" }}
                                    >
                                      <div className="d-flex  height-25 p-r-5 p-l-5 align-items-center justify-content-start ">
                                        {(() => {
                                          const streetAddress = [
                                            item?.main_contact?.[0]?.address1,
                                            item?.main_contact?.[0]?.address2,
                                          ]
                                            .filter(Boolean)
                                            .join(" "); // use space instead of comma

                                          const cityStateZip = [
                                            item?.main_contact?.[0]?.city,
                                            item?.main_contact?.[0]?.state,
                                            item?.main_contact?.[0]?.zip,
                                          ]
                                            .filter(Boolean)
                                            .join(","); // combine with spaces

                                          const fullAddress = [streetAddress, cityStateZip]
                                            .filter(Boolean)
                                            .join(", ");
                                          return fullAddress.length > 90
                                            ? fullAddress.substring(0, 90) + "..."
                                            : fullAddress;
                                        })()}
                                      </div>
                                    </td>
                                    <td />

                                    <td
                                      id="phone-padding-tables-new-provider"
                                      className="text-start p-l-5 p-r-5 color-black"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {formatPhoneNumber(item?.phone)}
                                    </td>
                                  </tr>
                                );
                              })}
                              {Array.from({
                                length: Math.max(0, 16 - attorneyData.length),
                              }).map((_, index) => (
                                <tr key={index} className="fake-rows-new-provider height-25">
                                  <td colSpan={12} />
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="addNewlawFirms">
                      <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
                        <Col md={12} className="p-0">
                          <div className="row mx-0 align-items-center custom-margin-bottom">
                            <div
                              className="col-md-12 height-25 ps-0 pe-0"
                              style={
                                {
                                  // maxWidth: "614px",
                                  // marginRight: "5px",
                                }
                              }
                            >
                              <input
                                type="text"
                                placeholder="Firm Name"
                                className="form-control p-0 p-l-5 rounded-0 height-25"
                                value={attorneyInfo.firmName}
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Firm Name";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                onChange={(e) =>
                                  setAttorneyInfo({
                                    ...attorneyInfo,
                                    firmName: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
                        <Col md={12} className="p-0">
                          <div className="row mx-0 align-items-center custom-margin-bottom">
                            <div className="col-md-4 p-l-0 height-25 pe-0">
                              <input
                                type="text"
                                placeholder="Address 1"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Address 1";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                value={attorneyInfo.address1}
                                onChange={(e) =>
                                  setAttorneyInfo({
                                    ...attorneyInfo,
                                    address1: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div className="p-l-5 col-md-3 height-25 p-r-5">
                              <input
                                type="text"
                                placeholder="Address 2"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Address 2";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                value={attorneyInfo.address2}
                                onChange={(e) =>
                                  setAttorneyInfo({
                                    ...attorneyInfo,
                                    address2: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div className="col-md-3 height-25 p-l-0 pe-0">
                              <input
                                type="text"
                                placeholder="City"
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "City";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                value={attorneyInfo.city}
                                onChange={(e) =>
                                  setAttorneyInfo({
                                    ...attorneyInfo,
                                    city: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div className="col-md-1 height-25 p-l-5 pe-0 custom-select-new-provider">
                              <div
                                className="dropdown-button rounded-0 p-0 p-l-5 p-r-5 form-control height-25 d-flex align-items-center"
                                onClick={handleStateShow}
                              >
                                <span id="selectedOption">
                                  {specialStates.includes(attorneyInfo?.state) ? (
                                    <div className="d-flex align-items-center">
                                      {React.createElement(stateMap[attorneyInfo.state])}
                                      {attorneyInfo?.state}
                                    </div>
                                  ) : attorneyInfo?.state ? (
                                    <div className="d-flex align-items-center">
                                      <svg
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          fill: "var(--primary-80)",
                                          color: "var(--primary-80)",
                                          stroke: "var(--primary-80)",
                                        }}
                                        className={`icon icon-state-${attorneyInfo?.state}`}
                                      >
                                        <use xlinkHref={`#icon-state-${attorneyInfo?.state}`} />
                                      </svg>
                                      {attorneyInfo?.state}
                                    </div>
                                  ) : (
                                    "State"
                                  )}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-1 height-25 p-l-5 pe-0">
                              <input
                                type="text"
                                placeholder="Zip"
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Zip";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                value={attorneyInfo.zip}
                                onChange={(e) =>
                                  setAttorneyInfo({
                                    ...attorneyInfo,
                                    zip: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
                        <Col md={12} className="p-0">
                          <div className="row mx-0 align-items-center custom-margin-bottom">
                            <div
                              className="col-md-2 height-25 p-l-0 p-r-5"
                              style={{
                                minWidth: "181px",
                              }}
                            >
                              <input
                                aria-label="Firm phone"
                                name="phone"
                                autoComplete="tel"
                                type="tel"
                                placeholder="Phone: (###) ###-####"
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Phone: (###) ###-####";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                value={attorneyInfo.phone}
                                onChange={handlePhoneInput}
                              />
                            </div>

                            <div
                              className="col-md-2 height-25 p-l-0 p-r-5"
                              style={{
                                minWidth: "181px",
                              }}
                            >
                              <input
                                aria-label="Firm fax"
                                name="fax"
                                autoComplete="off"
                                type="tel"
                                placeholder="Fax: (###) ###-####"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Fax: (###) ###-####";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                value={attorneyInfo.fax}
                                onChange={handleFaxInput}
                              />
                            </div>
                            <div
                              className="col-md-4 height-25 p-l-0 pe-0"
                              style={{
                                maxWidth: "351.5px",
                              }}
                            >
                              <input
                                spellCheck={false}
                                aria-label="Firm email (optional)"
                                name="email"
                                autoComplete="email"
                                type="email"
                                placeholder="Email (optional): someone@attorney.com"
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Email (optional): someone@attorney.com";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                value={attorneyInfo.email}
                                onChange={(e) => {
                                  setAttorneyInfo({
                                    ...attorneyInfo,
                                    email: e.target.value,
                                  });
                                }}
                              />
                            </div>

                            <div
                              className="col-md-4 height-25 p-l-5 pe-0 "
                              style={{
                                maxWidth: "356.5px",
                              }}
                            >
                              <input
                                type="text"
                                placeholder="Website: www.myattorney.com"
                                className="form-control height-25 p-0 p-l-5 rounded-0"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Website: www.myattorney.com";
                                }}
                                style={{ color: "var(--primary-25)" }}
                                value={attorneyInfo.website}
                                onChange={(e) => {
                                  setAttorneyInfo({
                                    ...attorneyInfo,
                                    website: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div
                        className={
                          "d-flex align-items-center justify-content-center text-uppercase cursor-default height-25 font-weight-semibold m-b-5 selected-option "
                        }
                      >
                        <span
                          className={
                            "generic-settlement-popup cursor-default text-center text-uppercase color-white"
                          }
                          style={{ padding: "5px" }}
                        >
                          Input User Information for the Firm
                        </span>
                      </div>

                      {[1, 2, 3, 4, 5, 6].map((itm, index) => {
                        const team = attorneyInfo?.teamData[index];
                        return (
                          <Row
                            key={itm}
                            style={{
                              paddingLeft: "5px",
                              paddingRight: "5px",
                            }}
                            className="mx-0"
                          >
                            <Col md={12} className="p-0">
                              <div className="row mx-0 align-items-center custom-margin-bottom">
                                <div className="col-md-3 p-l-0 height-25 pe-0">
                                  <input
                                    aria-label={`Team member ${index + 1} first name`}
                                    name={`team-${index + 1}-first_name`}
                                    autoComplete="given-name"
                                    type="text"
                                    placeholder="First Name"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "First Name";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    value={team.first_name}
                                    onChange={(e) => {
                                      updateTeamMember(index, "first_name", e.target.value);
                                    }}
                                  />
                                </div>

                                <div className="p-l-5 col-md-3 height-25 p-r-5">
                                  <input
                                    aria-label={`Team member ${index + 1} last name`}
                                    name={`team-${index + 1}-last_name`}
                                    autoComplete="family-name"
                                    type="text"
                                    placeholder="Last Name"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Last Name";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    value={team.last_name}
                                    onChange={(e) => {
                                      updateTeamMember(index, "last_name", e.target.value);
                                    }}
                                  />
                                </div>

                                <div className="col-md-3 height-25 p-l-0 pe-0">
                                  <input
                                    spellCheck={false}
                                    aria-label={`Team member ${index + 1} email`}
                                    name={`team-${index + 1}-email`}
                                    autoComplete="email"
                                    type="email"
                                    placeholder="Email: someone@user.com"
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Email: someone@user.com";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    value={team.email}
                                    onChange={(e) => {
                                      updateTeamMember(index, "email", e.target.value);
                                    }}
                                  />
                                </div>

                                <div className="col-md-3 height-25 p-l-5 pe-0">
                                  <input
                                    aria-label={`Team member ${index + 1} phone`}
                                    name={`team-${index + 1}-phone`}
                                    autoComplete="tel"
                                    type="tel"
                                    placeholder="Phone: (###) ###-####"
                                    className="form-control height-25 p-0 p-l-5 rounded-0"
                                    onFocus={(e) => {
                                      e.target.placeholder = "";
                                      e.target.style.color = "black";
                                    }}
                                    onBlur={(e) => {
                                      e.target.placeholder = "Phone: (###) ###-####";
                                    }}
                                    style={{ color: "var(--primary-25)" }}
                                    value={team.phone}
                                    onChange={(e) => {
                                      updateTeamMember(
                                        index,
                                        "phone",
                                        formatPhoneNumber(e.target.value)
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </Modal.Body>

          <Modal.Footer
            className="p-0 mt-0 padding-outside-btn-new-provider"
            style={{ borderTop: "none" }}
          >
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
              variant="secondary"
              onClick={close}
              disabled={saving}
            >
              Cancel
            </Button>

            <Button
              variant={"success"}
              // disabled={Object.keys(selectedProviderDirectory).length === 0}
              style={{
                // cursor:
                //   Object.keys(selectedProviderDirectory).length === 0
                //     ? "not-allowed"
                //     : "pointer",
                minWidth: "108px",
              }}
              onClick={handleByDirectory}
              disabled={saving}
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
            >
              {saving ? "Adding…" : "Add Co-Counselling Firm"}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      {stateShow && (
        <SelectStateModal
          show={stateShow}
          handleClose={handleStateShow}
          // onChange={onChange}
          onChange={(state) =>
            setAttorneyInfo({
              ...attorneyInfo,
              state: state.StateAbr,
            })
          }
          statesData={statesAbrs}
        />
      )}
    </>
  );
};

export default CounsellingModal;
